import { ref } from "vue";

const showConstraints = ref(false);
const collapsedElements = ref([]);

const isCollapsed = (groupToken) => collapsedElements.value.includes(groupToken);

const toggleCollapse = (groupToken) => {
  if (isCollapsed(groupToken)) {
    collapsedElements.value = collapsedElements.value.filter((t) => t !== groupToken);
  } else {
    collapsedElements.value.push(groupToken);
  }
};

const expandAll = () => {
  collapsedElements.value = [];
};

const collapseAll = (groupTokens) => {
  collapsedElements.value = [...groupTokens];
};

const resetBudgetView = () => {
  showConstraints.value = false;
  collapsedElements.value = [];
};

export const useBudgetView = () => ({
  showConstraints,
  collapsedElements,
  isCollapsed,
  toggleCollapse,
  expandAll,
  collapseAll,
  resetBudgetView,
});
